import React, {useEffect, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";


// components
import ServiceLocationForm from "./_form";
import ServiceLocationList from "./_list";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {showLoader} from "../../../components/loader/loader";

// labels

// actions
import { mapFunctions } from "../../../components/map/mapFunctions";
import { setForm } from "../../../redux/actions/generalActions/formActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import { clearState, setApp, setUdn, setMapConfig } from "../../../redux/actions/generalActions/mainActions";

// services & providers

function ServicesLocation(props) {
    const { loading } = props.mainProps
    const [googleConfig, setGoogleConfig] = useState( null );

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null

        if (udn !== null) {
            loadGoogleConfig( udn );
            props.setUdn(udn);
        }
    },[]);

    const loadGoogleConfig = ( _udn ) => {

        let _googleConfig = {}

        if (_udn?.id !== undefined){
            mapFunctions.loadMapConfig(_udn)
                .then(result => {
                    if (result?.data?.length > 0) {
                        let config = result?.data[0];
                        _googleConfig =  {
                            mapOptions: {
                                center: {
                                    lat: parseFloat(config?.latitude),
                                    lng: parseFloat(config?.longitude)
                                },
                                disableDefaultUI: false,
                                mapTypeControl: false,
                                rotateControl: false,
                                streetViewControl: false,
                                zoom: config.defaultZoom + 1,
                                minZoom: config.minZoom,
                                maxZoom: config.maxZoom + 3
                            },
                            overlay: {
                                udn: config.udnCode.toLowerCase(),
                                pto1: {
                                    lat: config.overlay1Lat,
                                    lng: config.overlay1Long
                                },
                                pto2: {
                                    lat: parseFloat(config.overlay2Lat),
                                    lng: parseFloat(config.overlay2Long)
                                }
                            },
                            bound: {
                                sw: {
                                    lat: parseFloat(config.bound2Lat),
                                    lng: parseFloat(config.bound2Long)
                                },
                                ne: {
                                    lat: parseFloat(config.bound1Lat),
                                    lng: parseFloat(config.bound1Long)
                                }
                            }
                        }

                        setGoogleConfig(_googleConfig);
                        props.setMapConfig(_googleConfig);
                    }

                })
                .catch(ex => {
                    console.log(ex);
                });
        }
    }

    const createItem = () => {
        props.setForm();
        props.setMapConfig(googleConfig);
        ModalFormContainer( ServiceLocationForm )
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <ServiceLocationList  googleConfig={googleConfig} />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    clearListState,
    setUdn,
    setForm,
    setApp,
    setMapConfig
});

export default connect(mapStateToProps, mapActionsToProps)(ServicesLocation)